import React, { useEffect, useState, useRef, useContext } from "react";
import { Alert } from "reactstrap";
import ArtistsTable from "../../components/artistsTable";
import Pagination from '../../components/pagination/pagination';
import TableModal from "../../components/tableModal";
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";
import { StateContext } from "../../utils/context";
import { getUser } from "../../utils/getUser";
import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";
import { Trans, useTranslation } from "react-i18next";

const Artists = props => {
   const { t } = useTranslation();
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [deleteBody, setDeleteBody] = useState(false);
  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  const [forceUpdate, setForce] = useState(1);

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };
  const [tableData, setTableData] = useState([]);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'name', sort: 'name'});
  const [subUser, setSubUser] = useState('');
  const [subUserEndpoint, setSubUserEndpoint] = useState('');
  const [parentUserOnly, setParentUserOnly] = useState('');

  const token = getCookie("token");
  const {currentUser, setCurrentUser} = useContext(StateContext);

  const [apiData, error, loading] = useFetch(
    "GET",
    `artists/${subUserEndpoint}?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}${parentUserOnly}`,
    token,
    false,
    forceUpdate
  );

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  useEffect(() => {
    if (apiData?.detail === "Invalid page.") {
      setCurrentPage(1);
      return;
    }

    if (apiData) {
      if(apiData.count) {
        setDataCount(apiData.count);
      }
      if(apiData.results) {
        setTableData(apiData.results);
      }
    }
  }, [apiData]);

  useEffect(() => {
    getUser(token, currentUser, setCurrentUser);
  }, [success, errorPut]);
  
  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name, subUser]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          {
            (currentUser.artists && (!currentUser.has_subscription || !currentUser.subscription_active || !currentUser.is_paid_subscription)) &&
            <Alert color="danger">
              <Trans i18nKey="artists.view.message.notSubscribed">
                You are not subscribed to any plan, therefore you can only add <b>3 Artists</b>, Please <a href="/dashboard/">subscribe</a> to a plan to avail unlimited amount of Artists.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.artists && currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="artists.view.message.subscriptionUpgrade">
                Your current subscription plan does not support this feature. Please <a href="/subscription/upgrade/">upgrade</a> your subscription plan to avail this feature.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.artists && !currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="artists.view.message.subscriptionExpired">
                Your subscription has expired. Please <a href="/subscription/">resume</a> your subscription to avail this feature.
              </Trans>
            </Alert>
          }
          { 
            (!currentUser.artists && !currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="artists.view.message.noAccess">
                You don't have access to this module, please contact the support team for further information.
              </Trans>
            </Alert>
          }
          {
            (currentUser.artists) &&
            <>
              <ViewLayout title={t("artists.view.table.title")}>
                <ArtistsTable
                  {...tableProps}
                  setToggleModal={setToggleModal}
                  setDataModal={setDataModal}
                  setDeleteBody={setDeleteBody}
                  forceUpdate={forceUpdate}
                  searchQuery={{setQuery, query, ordering, setOrdering}}
                  subUserData={{subUser, setSubUser, subUserEndpoint, setSubUserEndpoint, setParentUserOnly}}
                  />
              </ViewLayout>
              <Pagination pagination={paginationProps}/>
            </>
          }
        </div>
      )}

      {dataModal && (
        <TableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={
            deleteBody ? (
              !dataModal.can_be_deleted?
                t("artists.view.modal.cantBeDeleted.header", {artistName: dataModal.name}):
                t("artists.view.modal.delete.header", {artistName: dataModal.name})):
                t("artists.view.modal.edit.header", {artistName: dataModal.name})
          }
          body={
            deleteBody? (
              !dataModal.can_be_deleted?
                t("artists.view.modal.cantBeDeleted.body", {artistName: dataModal.name}):
                t("artists.view.modal.delete.body", {artistName: dataModal.name})
            ): t("artists.view.modal.edit.body", {artistName: dataModal.name})
          }
          apiURL={`artists/${dataModal.id}/`}
          bodyID={dataModal.id}
          deleteBody={deleteBody}
          can_be_deleted={dataModal.can_be_deleted}
        />
      )}
      {success && <Alert color="success">{t("artists.view.message.success")}</Alert>}
      {errorPut && (
        <Alert color="danger">
          {t("artists.view.message.error")}
        </Alert>
      )}
    </>
  );
};

export default Artists;
